import React from 'react';
import { CommentOutlined, AppstoreOutlined } from '@ant-design/icons';
import BaseButton from 'components/atoms/baseButton';
import { Flex, Tooltip } from 'antd';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import styles from './styles.module.scss';
import CallDropdownButton from './call-dropdown-button';
import SmsDropdownButton from './sms-dropdown-button';

import type { FC } from 'react';
import type { ModuleType } from 'infrastructure/enums';

export interface PatientActionButtonsProps {
  patientGuid: string;
  module: ModuleType;
  onComment?: () => void;
  onMore?: () => void;
  wrapper?: 'div' | 'none';
  wrapperClassName?: string;
}

const PatientActionButtons: FC<PatientActionButtonsProps> = ({
  patientGuid,
  module,
  onComment,
  onMore,
  wrapper = 'div',
  wrapperClassName,
}) => {
  const { isCombinedModule, isReadOnlyRole, isCcmActionDisabled } = useAccess({
    module,
    patientGuid,
  });

  const buttons = (
    <>
      <CallDropdownButton patientGuid={patientGuid} module={module} />
      <SmsDropdownButton patientGuid={patientGuid} module={module} />
      <BaseButton
        label="General Comment"
        icon={<CommentOutlined />}
        onClick={onComment}
        type="secondary"
        className={styles['action-button']}
        disabled={isCombinedModule ? isReadOnlyRole : isCcmActionDisabled}
      />
      <Tooltip title="Control Panel">
        <span>
          <BaseButton
            icon={<AppstoreOutlined />}
            onClick={onMore}
            type="secondary"
            className={styles['control-panel-button']}
          />
        </span>
      </Tooltip>
    </>
  );

  if (wrapper === 'none') {
    return buttons;
  }

  return <Flex className={wrapperClassName}>{buttons}</Flex>;
};

export default PatientActionButtons;
